import { render, staticRenderFns } from "./RateCardBulkUpdate.vue?vue&type=template&id=440285c8&"
import script from "./RateCardBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./RateCardBulkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports